import { useState } from 'react'
import MultipleCostInvoiceModal from 'tennders-finance/cost-invoice/modals/MultipleCostInvoiceModal'
import { apiGet } from 'tennders-stracture/libs/api'

const useMultipleCostInvoiceModal = ({ refresh, selectedTransaction, initialForm, isQC }) => {
  const [showModal, setShowModal] = useState(false)
  const [form, setForm] = useState({ })
  const show = (e) => {
    if (e) {
      e.preventDefault()
    }
    setShowModal(true)
  }

  const hide = () => {
    setShowModal(false)
    if (refresh) {
      refresh()
    }
  }

  const initInvoice = (id) => {
    apiGet('/costInvoice/' + id + (isQC ? '?qc=true' : '')).then(res => {
      setForm(res)
      setShowModal(true)
    })
  }

  return {
    show,
    hide,
    initInvoice,
    showing: showModal,
    modal: showModal ? (
      <MultipleCostInvoiceModal
        initialForm={initialForm || form}
        selectedTransaction={selectedTransaction}
        onClose={hide} />
    ) : null

  }
}

export default useMultipleCostInvoiceModal
